import axios from 'axios'

const baseUri = (window.location.origin.indexOf('aadalen.no') == -1 && window.location.origin.indexOf('aadalenutleie.no') == -1 ? 'https://aadalen.no' : window.location.origin) + '/index.php/wp-json/'

/**
 * Create and process the request
 */
async function sendRequest (requestMethod, requestUrl, bodyData = null, headers = {}) {
    return axios({
        auth: {
          username: 'ck_39fa323b6ffb4ced9ddd255a2c898837',
          password: 'cs_d028545d9e9f4fc6b4416fd4807d76aa'
        },
        headers: headers,
        method: requestMethod,
        data: bodyData,
        url: baseUri + requestUrl
    })
}

async function getCourses () {
    return sendRequest('GET', 'course-calendar/get/');
}

async function registerToCourse (courseId, account, address, contacts) {
    return sendRequest('POST', `course-calendar/register/?workorder=${courseId}`, { 'account': account , 'address': address, 'contacts': contacts });
}

function getSearchEndpoint () {
    return baseUri + 'course-calendar/search-customer/';
}

export default {
    getCourses,
    registerToCourse,
    getSearchEndpoint
};
